import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";

function GlobalMarkets() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Global Markets"
          title={`Financial
              <span className="jumbotron-subtitle-2">
                Institutions
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              As domestic and international financial institutions become
              increasingly involved in commodity and trade finance, there is a
              greater need for customised banking and trade services. alrajhi
              bank Malaysia seeks to fill the gap where a financial institution
              may not be able to address these growing trade finances needs on
              their own.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default GlobalMarkets;
